import React from 'react';
import LoaderImage from '../assets/loader.gif'; // Adjust the path as necessary
import { Box, Typography } from '@mui/material';

const LoadingSpinner = ({ fullPage = false }) => {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: fullPage ? '100vh' : '100%',
          width: fullPage ? '100vw' : '100%',
          backgroundColor: fullPage ? '#f0f0f0' : 'transparent',
        }}
      >
        <img src={LoaderImage} alt="Loading..." style={{ width: 100, height: 100 }} />
        <Typography variant="h5" sx={{ marginTop: 2, color: "black" }}>
          Loading, please wait...
        </Typography>
      </Box>
    </Box>
  );
};

export default LoadingSpinner;